import React, { useCallback, useEffect, useState } from 'react'
import { Box, Grid, Skeleton, Typography } from '@mui/material'
import isEmpty from 'lodash/isEmpty'
import { handlerErrorV2 } from '../../../../../utils/errors'
import { getSubjects } from '../../../../../services/subjects/subjects.service'
import SelectField from '../../../../FormControl/input/SelectField'
import FormCurriculumElements from '../FormCurriculumElements/FormCurriculumElements'
import { useSelector } from 'react-redux'

const FormSubject = ({ onChange, form = {}, errors = {}, showTitle, curriculumId }) => {
  const [subjects, setSubjects] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const existLinceseAssessment = useSelector((state) =>
    state?.tenant?.license?.find((license) => license.code === 'assessment')
  )

  const onLoad = useCallback(async () => {
    try {
      let filter = {}
      if (form?.curriculumElements?.elementId) {
        filter = {
          curriculumelements: {
            elementId: form?.curriculumElements?.elementId
          }
        }
      }

      if (!isEmpty(filter)) {
        setIsLoading(true)
        const response = await getSubjects(form.curriculumId, filter)
        if (!response?.data && response?.error) {
          // const message = response.error.message || 'An error ocurred';
          // setInputErrors({ message })
        } else {
          setSubjects(response.data)
          const find = response.data.find((item) => item._id === form.subjectId)
          if (!find) {
            onChange('subjectId', '')
          }
        }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      // setInputErrors({ message })
    } finally {
      setIsLoading(false)
    }
  }, [form.curriculumId, form.curriculumElements])

  useEffect(() => {
    onLoad()
  }, [onLoad])

  return (
    <>
      {existLinceseAssessment && (
        <FormCurriculumElements
          showTitle={showTitle}
          form={form}
          errors={errors}
          onChange={onChange}
          curriculumId={curriculumId}
        />
      )}
      {showTitle && (
        <Box className='px-4 py-2 h-6 bg-primary text-primary-foreground flex items-center'>
          <Typography variant='inherit' className='font-bold capitalize' component='p'>
            Subject
          </Typography>
        </Box>
      )}
      <Box className={showTitle ? 'px-4 py-4' : ''}>
        <Grid container spacing={2} alignItems='center'>
          <Grid item sm={3}>
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              Subject
            </Typography>
          </Grid>
          <Grid item sm={9}>
            {form?.unitOfLearnings?.length > 0 ? (
              <Typography variant='inherit' component='p'>
                {isLoading && <Skeleton variant='text' width={100} />}
                {!isLoading &&
                  subjects
                    ?.filter((item) => form?.subjectId?.includes(item._id))
                    .map((item) => item.name)
                    .join(', ')}
              </Typography>
            ) : (
              <SelectField
                id='subjectId'
                name='subjectId'
                error={errors.subjectId}
                helperText={errors.subjectId}
                value={form.subjectId || ''}
                onChange={(e) => onChange('subjectId', e.target.value)}
                options={subjects?.map((item) => ({ value: item._id, label: item.name })) || []}
                placeholder='Choose an option'
                loading={isLoading}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default FormSubject
